// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federherstellung/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federherstellungDE: PageEntry = {
  id: "post.federherstellung",
  locale: "de",
  slug: "federherstellung",
  seo: {
    title: "Glossar: Federherstellung einfach erklärt | Dietz GmbH",
    description: "Die Federherstellung ist der Prozess der Fertigung von Federn, bei dem Rohmaterialien durch verschiedene Verfahren in die gewünschte Federform gebracht werden. Dieser Prozess kann ",
  },
  type: "post",
  h1: "Glossar: Federherstellung einfach erklärt",
  intro: "Die Federherstellung ist der Prozess der Fertigung von Federn, bei dem Rohmaterialien durch verschiedene Verfahren in die gewünschte Federform gebracht werden. Dieser Prozess kann verschiedene Techniken wie Drahtziehen, Biegen, Wickeln und Wärmebehandlung umfassen. Die Auswahl der geeigneten Herstellungstechniken hängt von Faktoren wie Federart, Anwendung und Material ab. Hochpräzise Fertigungsprozesse sind entscheidend, um Federn mit den erforderlichen mechanischen Eigenschaften herzustellen. Moderne Fertigungstechnologien tragen dazu bei, die Effizienz und Genauigkeit der Federherstellung zu verbessern.",
  blocks: [

  ],
};
